/**
 * 对外全局数据store
 */
import {makeObservable, observable, action, flow} from 'mobx';
import _ from 'lodash';
import {getStorage, setStorage} from '../../../utils/storage';

export class ExternalStore {
    showExternalModal = false; // 是否显示对外授权弹窗
    // curLoginAccount = {
    //     'anchor_id': 'C7Kzvbz8ncCP3SE5R0bGwA',
    //     'check_time': '2024-06-20T14:55:29+08:00',
    //     'id': 25,
    //     'login_time': '2024-06-20T11:16:55+08:00',
    //     'platform': 5,
    //     'status': 1,
    //     'third_avatar': 'http://huibo-data.bj.bcebos.com/upload_image/open/avatar/a5756bce-ca0c-4a64-ac83-44161aa948cc.jpg',
    //     'third_id': 'nOdwbyg7bawlyCAquVBTbkgmkhiqrXNnXIP3vDZyol0',
    //     'third_kind': 2,
    //     'third_nick': '从了老子'
    // }; // 当前登录的账号
    curLoginAccount = null; // 当前登录的账号，默认空，轮询插件确认状态后赋值
    pollingCheckLoginTask = null;
    authList = []; // 授权列表

    constructor() {
        makeObservable(this, {
            showExternalModal: observable,
            curLoginAccount: observable,
            pollingCheckLoginTask: observable,
            authList: observable
        });
    }

    setShowExternalModal = (show) => {
        this.showExternalModal = show;
    };

    setCurLoginAccount = (account) => {
        this.curLoginAccount = account;
        setStorage('huibo_external_cur_login_account', account);
    };

    setPollingCheckLoginTask = (task) => {
        this.pollingCheckLoginTask = task;
    };

    setAuthList = (list) => {
        this.authList = list;
    };
}
